import { useMutation, gql } from '@apollo/react-hooks';
import { useCallback } from 'react';
import type { DeleteFindingMutation } from '#/graphql/types';
import { deleteFinding } from '#/graphql/mutations';
import { get } from 'lodash';

const q = gql(deleteFinding);

const useFindingDelete = () => {
  const [mutation, result] = useMutation<DeleteFindingMutation>(q);
  const deleteFinding = useCallback(
    async (itemId: string) => {
      const response = await mutation({
        variables: {
          id: itemId,
        },
      });

      return get(response, 'data.deleteFinding.data', undefined);
    },
    [mutation],
  );

  return { deleteFinding, result };
};

export default useFindingDelete;
